import {connect} from "react-redux";
import {bindActionCreators} from "redux";
import IndustryMaster from "./industryMaster";

const mapStateToProps = () => ({});
const mapDispatchToProps = (dispatch) => ({
    actions: bindActionCreators(
        {},
        dispatch
    )
});

export default connect(mapStateToProps, mapDispatchToProps)(IndustryMaster);
